/**
 * Created by falknisius on 19.05.17.
 */
import Reflux from "reflux";
import APIService from "../services/APIService";

let themeStoreActions = Reflux.createActions({
  'fetchTheme': {children: ['completed', 'failed']},
  'setQueryParams': {},
  'setDeviceUuid': {}
})

// themeStoreActions.fetchTheme.listen( function (queryParams) {
//   APIService.getThemeAndGroupName(queryParams)
//     .then(this.completed)
//     .catch(this.failed)
// })

export default themeStoreActions



// WEBPACK FOOTER //
// ./src/stores/ThemeStoreActions.js